<template>
  <div class="person_card_center">
    <el-row class="person_card_wrap" type="flex" justify="space-between">
      <el-col class="card_item" :span="11" :xs="24">
        <img src="~@/assets/img/zhejiang.png" alt="" />
        <h2>浙华省人民政府</h2>
        <div class="card_bg"></div>
        <div class="card_desc">
          浙江省人民政府（The People's Government of Zhejiang
          Province），是中华人民共和国浙江省的国家行政机关，是浙江省人民代表大会的执行机关，对浙江省人民代表大会和中华人民共和国国务院负责并报告工作，在浙江省人民代表大会闭会期间，对浙江省人民代表大会常务委员会和中华人民共和国国务院负责并报告工作，依法行使行政职权。
        </div>
      </el-col>
      <el-col class="card_item" :span="11" :xs="24">
        <img src="~@/assets/img/qinghua.png" alt="" />
        <h2>清华大学</h2>
        <div class="card_bg"></div>
        <div class="card_desc">
          清华大学（Tsinghua University），简称“清华”，位于北京市海淀区清华园，
          [142]由教育部与北京市重点共建，
          [47]是中华人民共和国教育部直属的全国重点大学，中央直管高校
          [145]，国家首批“双一流”A类、“985工程”、“211工程”重点建设高校。
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.person_card_center {
  width: 70%;
  margin: 50px auto;
  @media screen and (max-width: 768px) {
    width: 90%;
  }
  .person_card_wrap {
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: space-between;
    }
    .card_item {
      border-radius: 10px;
      background: #fff;
      box-shadow: 5px 5px 10px #eee, -5px -5px 10px #fff;
      img {
        width: 100%;
        height: 300px;
        @media screen and (max-width: 768px) {
          height: 240px;
        }
      }
      color: #000;
      padding: 30px;
      &:nth-child(2) {
        @media screen and (max-width: 768px) {
          margin-top: 1rem;
        }
      }
      h2 {
        color: #000;
        font-size: 30px;
        @media screen and (max-width: 768px) {
          font-size: 24px;
        }
      }
      p {
        font-size: 18px;
        @media screen and (max-width: 768px) {
          font-size: 13px;
          padding: 10px 0;
        }
      }
      @media screen and (max-width: 768px) {
        height: auto;
        padding: 20px;
        background-size: cover;
        color: #000;
      }
      .card_bg {
        width: 35px;
        height: 5px;
        margin-top: 10px;
        background: #000;
        @media screen and (max-width: 768px) {
          width: 20px;
          height: 3px;
        }
      }
      .card_desc {
        color: #000;
        margin-top: 30px;
        line-height: 1.5rem;
        font-size: 16px;
        @media screen and (max-width: 768px) {
          color: #000;
          font-size: 12px;
        }
      }
    }
  }
}
</style>